// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"16acf05e","99":"6ddc6bae","246":"3cd4d194","325":"540113d5","372":"2e309eec","409":"777ce355","461":"d1f37bc3","490":"a7469037","532":"d5d7d3a8","569":"33dad97e","887":"90846376","958":"c3b0d3ff","964":"0568a599","993":"13aced15"}[chunkId] + ".chunk.js";
};